<!--
 * @Descripttion: 
 * @Version: 1.0.0
 * @Author: Li Yong
 * @Date: 2022-03-25 11:10:06
 * @LastEditors: Li Yong
 * @LastEditTime: 2022-03-30 13:42:21
-->
<template>
  <el-form :model="formData" ref="form" :rules="rules">
    <el-form-item prop="specified_shop_ids">
      <el-input
        v-model="formData['specified_shop_ids']"
        type="textarea" :rows="6" show-word-limit maxlength="200"
        placeholder="请粘贴指定商家的店铺ID，支持批量粘贴，请用英文 “,” 隔开，最多50个店铺ID"
        style="width: 400px" resize="none"
        @input="val => change('specified_shop_ids', val)"
      ></el-input>
      <p><a :href="helpUrl" target="_blank" class="link">如何获取店铺ID？</a></p>
    </el-form-item>
  </el-form>
</template>
<script>
import mixin from '../../../../mixin';
export default {
  name: 'SpecialShopForm',
  mixins: [mixin],
  data() {
    return {
      formData: {
        specified_shop_ids: ''
      },
      rules: {
        specified_shop_ids: [{required: true, message: '店铺ID不可为空'}]
      },
      helpUrl: 'https://yangxuan.feishu.cn/docs/doccnKywldcmWRKDUduCfKtmQ3d'
    }
  },
  methods: {
    validate() {
      return new Promise((resolve, reject) => {
        this.$refs.form.validate((valid) => {
          if (valid) {
            resolve({...this.formData});
          } else {
            reject(valid);
            return false;
          }
        });
      })
    },
    resetForm() {
      this.$refs.form.resetFields();
    },
    isFormModified() {
      return this.isModified;
    }
  }
}
</script>
<style lang="less" scoped>
.link {
  color: @color-primary;
}
</style>